/**
 * Lightweight client-side pub/sub for credit-balance invalidations.
 *
 * Booking, cancellation, refund, and purchase flows call
 * `notifyCreditsChanged()` after a successful API write. Long-lived
 * components that display credit balances (notably the navbar
 * `StudentCreditBubble`) subscribe via `useEffect` and refetch.
 *
 * We don't have SWR / react-query in the app, and a stateless DOM event
 * is cheaper than wiring a context provider through the whole tree.
 */
export const CREDITS_CHANGED_EVENT = "rawiah:credits-changed";

export function notifyCreditsChanged(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(CREDITS_CHANGED_EVENT));
}
